"use client";
import { motion } from "framer-motion";
import { MdFaceUnlock } from "react-icons/md";
import { itemVariants } from "./motion";
import { useNavigate } from "react-router-dom";

export default function ActiveCases({ cases = [] }) {
  const navigate = useNavigate();

  return (
    <motion.div
      variants={itemVariants}
      className="bg-white p-4 md:p-6 rounded-lg shadow-customHigh w-full max-h-[570px] text-sm md:text-base overflow-hidden "
    >
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-medium">Active Cases</h2>
        <span className="text-lg font-medium">
          {cases.length.toString().padStart(2, "0")}
        </span>
      </div>

      {/* Scrollable Container */}
      <div className="space-y-3 max-h-[470px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 pr-2">
        {cases.map((user, index) => (
          <div
            key={index}
            className="bg-[#005787] text-white p-4 rounded-lg flex items-center justify-between"
          >
            <div className="flex items-center space-x-3 min-w-0">
              <div className="bg-white p-1.5 rounded-full">
                <MdFaceUnlock className="h-8 w-8 md:w-12 md:h-12 text-black" />
              </div>
              <div className="min-w-0 max-w-[140px] sm:max-w-[190px] md:max-w-[260px]">
                <div className="font-medium whitespace-normal break-all leading-tight">
                  {user?.firstName + " " + user?.lastName}
                </div>
                <div className="text-sm opacity-90 whitespace-normal break-all leading-tight">{user?.country}</div>
              </div>
            </div>
            <button
              onClick={() => navigate(`/agent/leads/${user?._id}`)}
              className="text-sm bg-[#1E1E1E] px-3 py-1 rounded-full hover:bg-[#1f1f1fc2] transition-colors"
            >
              View
            </button>
          </div>
        ))}
          {cases.length === 0 && <p className="text-red-500 pt-5 text-center" >No Active Cases Found</p> }

      </div>
    </motion.div>
  );
}
